import React, { useState, useEffect, useContext, useRef } from "react";
import { compose } from "redux";

import Tinymce from "fantastic/components/common/Tinymce";
import styles from "fantastic/components/hoc/styles";

import connectActions from "fantastic/lib/connectActions";
import actions from "fantastic/actions";
import setSelected from "fantastic/actions/setSelected";
import DraggingContext from "fantastic/lib/DraggingContext";
// import RangeContext from "fantastic/lib/RangeContext";

const Block = ({ id, style, contents, update, preview, checkContrast, openPrompt, select }) => {
  const [edit, setEdit] = useState(false);
  // const [range, setRange] = useState(null);
  //
  const editorRef = useRef();

  const handleChange = value => {
    update(id, { contents: value });
  };

  useEffect(() => {
    if (!preview) setEdit(false);
  }, [preview]);

  const isActive = () => {
    if(preview) return true;

    const { dragging } = useContext(DraggingContext);
    return edit && !dragging;
  }

  const active = isActive();

  const handleSelected = (e) => {
    const rng = tinyMCE.activeEditor.selection.getRng();

    if (editorRef.current && rng && editorRef.current.contains(rng.commonAncestorContainer)) {
      window.range = rng.collapsed ? null : rng;
    }
  }

  return (
    <div style={style}>
      <div
        style={{ display: active ? "none" : "block" }}
        dangerouslySetInnerHTML={{ __html: contents }}
      />
      <div
        style={{ display: active ? "block" : "none" }}
        onClick={event => {
          if (preview) {
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
          //forbid(true);
        }}
      >
        <Tinymce
          html={contents}
          onChange={handleChange}
          onInit={(e, editor) => {
            setEdit(true);
            window.range = null;
            editor.addCommand('mcePrompt', function () {
                // ed.execCommand("mceInsertContent", false, "<input type='number' value='123' />");
                select(id);
                openPrompt(id, true);
            });
            // if (window.rng) {
            //   tinyMCE.activeEditor.selection.setRng(window.rng);
            // }
            // console.log(editor.getBody());
            editorRef.current = editor.getBody();
          }}
          onActivate={handleSelected}
          disabled={preview}
        />
      </div>
    </div>
  );
};

export default compose(
  connectActions({
    update: actions.updateNode,
    openPrompt: actions.setPrompt,
    select: setSelected,
  }),
  styles("background", "padding", "visibility")
)(Block);
